import { Injectable, Inject } from '@angular/core';
import { JL } from 'jsnlog';
import { BehaviorSubject, of } from 'rxjs';
import { DropCombo } from '../../models/DropCombo';
import { Response } from '../../models/Response';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { SharedService } from '../../shared.service';


export class DropdownExplotacionService {

  private JL: JL.JSNLog;
  private: number;
  private codEspecie: string;
  public dataItemsBehaviorSubject = new BehaviorSubject<DropCombo[]>([]);

  constructor(@Inject('JSNLOG') JL: JL.JSNLog, public http: HttpClient, public sharedService: SharedService) {
    this.JL = JL;
  }

  cargarData(codEspecie: string) {
    if (codEspecie != this.codEspecie) {
      this.codEspecie = codEspecie;
      this.http.get<Response>(this.sharedService.WebURL + `/Explotacion/GetExplotacionesCombo/${codEspecie}`)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            //this.JL("Angular.DropExplotacionService").error(err);

            return of(new Response(-1, "Error al consultar las explotaciones para el dropdown", null));
          })
        )
        .subscribe((response: Response) => {
          if (response.response_code < 0) {
            // TODO: popup rojo error
            this.dataItemsBehaviorSubject.next([]);
          } else {
            this.dataItemsBehaviorSubject.next([...response.data]);
          }
        }, error => {
          this.JL("Angular.DropdownExplotacionService").error(error);
          // TODO: popup rojo error
        });
    } else {
      this.dataItemsBehaviorSubject.next(this.dataItemsBehaviorSubject.getValue());
    }
  }
}

export class DropdownEspecieService {

  private JL: JL.JSNLog;
  private: number;
  private codEntidad: string;
  public dataItemsBehaviorSubject = new BehaviorSubject<DropCombo[]>([]);

  constructor(@Inject('JSNLOG') JL: JL.JSNLog, public http: HttpClient, private sharedService: SharedService) {
    this.JL = JL;
  }

  cargarData(codEntidad: string) {
    if (codEntidad != this.codEntidad) {
      this.codEntidad = codEntidad;
      this.http.get<Response>(this.sharedService.WebURL + `/Especie/GetEspeciesCombo/${codEntidad}/${true}`)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            //this.JL("Angular.DropExplotacionService").error(err);

            return of(new Response(-1, "Error al consultar las especies para el dropdown", null));
          })
        )
        .subscribe((response: Response) => {
          if (response.response_code < 0) {
            // TODO: popup rojo error
            this.dataItemsBehaviorSubject.next([]);
          } else {
            this.dataItemsBehaviorSubject.next([...response.data]);
          }
        }, error => {
          this.JL("Angular.DropdownEspecieService").error(error);
          // TODO: popup rojo error
        });
    } else {
      this.dataItemsBehaviorSubject.next(this.dataItemsBehaviorSubject.getValue());
    }
  }
}

export class DropdownEspeciePRService {

  private JL: JL.JSNLog;
  private: number;
  private codEntidad: string;
  public dataItemsBehaviorSubject = new BehaviorSubject<DropCombo[]>([]);

  constructor(@Inject('JSNLOG') JL: JL.JSNLog, public http: HttpClient, private sharedService: SharedService) {
    this.JL = JL;
  }

  cargarData(codEntidad: string) {
    if (codEntidad != this.codEntidad) {
      this.codEntidad = codEntidad;
      this.http.get<Response>(this.sharedService.WebURL + `/Especie/GetEspeciesCombo/${codEntidad}/${false}`)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            //this.JL("Angular.DropExplotacionService").error(err);

            return of(new Response(-1, "Error al consultar las especies para el dropdown", null));
          })
        )
        .subscribe((response: Response) => {
          if (response.response_code < 0) {
            // TODO: popup rojo error
            this.dataItemsBehaviorSubject.next([]);
          } else {
            this.dataItemsBehaviorSubject.next([...response.data]);
          }
        }, error => {
          this.JL("Angular.DropdownEspeciePRService").error(error);
          // TODO: popup rojo error
        });
    } else {
      this.dataItemsBehaviorSubject.next(this.dataItemsBehaviorSubject.getValue());
    }
  }
}

export class DropdownMesService {

  private JL: JL.JSNLog;
  private: number;
  public dataItemsBehaviorSubject = new BehaviorSubject<DropCombo[]>([]);

  constructor(@Inject('JSNLOG') JL: JL.JSNLog, public http: HttpClient, private sharedService: SharedService) {
    this.JL = JL;
  }

  cargarData(fechas: Date[]) {
    if (fechas && fechas.length > 0) {
      var theMonths = new Array("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre");
      var array = []
      for (var i = 0; i < fechas.length; i++) {
        let dateArray = fechas[i].toString().split('/');
        let fecha = new Date(parseInt(dateArray[2]), parseInt(dateArray[1]) - 1, parseInt(dateArray[0]));
        var month = theMonths[fecha.getMonth()];
        var year = fecha.getFullYear();
        array.push({ id: (fecha.getMonth() + 1) + "-" + year, nombre: month + " " + year });
      }

      //var now = new Date();
      //var array = []
      //for (var i = 0; i < 18; i++) {
      //  var future = new Date(now.getFullYear(), now.getMonth() - i, 1);
      //  var year = future.getFullYear();
      //  var matchDate = fechas.find(function (element) {
      //    let dateArray = element.toString().split('/');
      //    let fecha = new Date(parseInt(dateArray[2]), parseInt(dateArray[1]) - 1, parseInt(dateArray[0]));
      //    return (fecha.getMonth() == future.getMonth() && fecha.getFullYear() == year);
      //  });
      //  if (matchDate) {
      //    var month = theMonths[future.getMonth()];
      //    array.push({ id: (future.getMonth() + 1) + "-" + year, nombre: month + " " + year });
      //  }
      //}
      this.dataItemsBehaviorSubject.next([...array]);
    } else {
      this.dataItemsBehaviorSubject.next([]);
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class DropdownGeneralService {

}
